// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"91":"ef966764","131":"f193c1bf","167":"5b9fb1e1","213":"4a1bf2b4","453":"e317d4ba","595":"52234e53","606":"5a5c0522","669":"3a0a272d","674":"a838990b","809":"7cdd7414","845":"43558dc8","860":"912f9438","885":"d06bc7b4"}[chunkId] + ".chunk.js";
};